/*
 * WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement - Deepthi N H
 * */
import React, { Component } from 'react';
import * as $ from 'jquery';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next';
import * as OrderEntryAction from '../actions/OrderEntryAction';
import OrderEntryStore from '../stores/OrderEntryStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as MenuAction from '../actions/MenuAction';
import Copy from 'copy-to-clipboard';
import swal from 'sweetalert';
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import WOPartsComponent from '../components/WOPartsComponent';
let currentPagePath;

class OrderEntryComponent extends Component {
    _isMounted = false;
    /**
  * Ref: LN_PC_04
  * Define the constructor that takes props as parameter
  * 
  * @param props
  */
    constructor(props) {
        super(props);
        //WAL-1034_PC_41 -Aparna
        this.AnykeyPress = this.AnykeyPress.bind(this);
        this.WOText = React.createRef();
        this.state = {
            POGridArray: [], isFavorited: false, VendorName: "", VendorArray: [], WONUM: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
            IsValidWO: localStorage.getItem("WONum") != null ? true : false, GeneratedPo: "", IsPOGenerated: false, isCreateNew: false,
            WO_Parts: localStorage.getItem("WO_Parts") != null && localStorage.getItem("WO_Parts") != undefined && localStorage.getItem("WO_Parts") != "" ? JSON.parse(localStorage.getItem("WO_Parts")) : [] //Bug :3618
        };
    };
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        OrderEntryAction.getCurrentFavPage(getFavPageBO);
        this.Page_Load();
        //WAL-1034_PC_
        if (localStorage.getItem("WONum") != null) {
            $("#OLWorkOrderTB").addClass("disabledbutton");
        }
        OrderEntryStore.on('OrdEntPageLoad', this.PageLoad_Response);
        OrderEntryStore.on('OrdEntGetPoDet', this.GetVendor_Response);
        OrderEntryStore.on('OrdEntCreateNew', this.CreateNewBtn_Response);
        OrderEntryStore.on('favpage', this.loadFavPageResponse.bind(this));
        OrderEntryStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        ShoppingCartStore.on('workordercheck', this.Workorderresponse);
        ShoppingCartStore.on('WOfail', this.workorderfail);
    };
    componentWillUnmount() {
        OrderEntryStore.removeListener('OrdEntPageLoad', this.PageLoad_Response);
        OrderEntryStore.removeListener('OrdEntGetPoDet', this.GetVendor_Response);
        OrderEntryStore.removeListener('OrdEntCreateNew', this.CreateNewBtn_Response);
        OrderEntryStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        OrderEntryStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        ShoppingCartStore.removeListener('workordercheck', this.Workorderresponse);
        ShoppingCartStore.removeListener('WOfail', this.workorderfail);
    };
    // ASOE_PC_11 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    Page_Load = () => {
        let Page_LoadBO = {
            ISA_EMPLOYEE_ID: CookieService.getLocalStorageValues("Session_UserID"),
            BUSINESS_UNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        OrderEntryAction.Page_Load(Page_LoadBO);
    };
    // ASOE_PC_12 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    PageLoad_Response = () => {
        let PageLoadRes = JSON.parse(OrderEntryStore.PageLoadData);
        let VendorArr = PageLoadRes.VendorTable;
        let PODetails = PageLoadRes.PODetailsBO;

        if (PODetails != undefined && PODetails.length > 0) {
            PODetails.forEach((value, index) => {
                let OrderNo = "";
                OrderNo = value.ORDER_NO;
                value.POID = "W01" + OrderNo.substring(3, 10);
            });
        };
        let locvenArr = [];
        if (VendorArr != undefined && VendorArr.length > 0) {
            VendorArr.map((val, index) => {
                let locVenObj = {
                    value: val.VENDOR_ID,
                    label: val.VENDOR_NAME
                };
                locvenArr.push(locVenObj);
            });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({ POGridArray: PODetails, VendorArray: locvenArr });
    };
    // ASOE_PC_15 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    GoButton_Click = () => {
        if (this.state.VendorName == "" || this.state.VendorName == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Select a Vendor Name'
            });
            // alert('Please Select a Vendor Name');
            return;
        }
        else {
            let GetVendorPOBO = {
                ISA_EMPLOYEE_ID: CookieService.getLocalStorageValues("Session_UserID"),
                BUSINESS_UNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Vendor_ID: this.state.VendorName.value
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            OrderEntryAction.Get_VendorPo(GetVendorPOBO);
        }

    };
    // ASOE_PC_16 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    GetVendor_Response = () => {
        let VendorPOs = JSON.parse(OrderEntryStore.OrdEntGetPo);
        let PODetails = VendorPOs.PODetailsBO;

        if (PODetails != undefined && PODetails.length > 0) {
            PODetails.forEach((value, index) => {
                let OrderNo = "";
                OrderNo = value.ORDER_NO;
                value.POID = "W01" + OrderNo.substring(3, 10);
            });
        };
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({ POGridArray: PODetails });
    };
    // ASOE_PC_17 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    CreateNewBtn_Click = () => {

        if (!this.state.IsValidWO) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Enter Valid Work Order #'
            });
            // alert('Please enter a valid Work Order');
            return;
        }
        if (this.state.VendorName == "" || this.state.VendorName == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select a Vendor Name'
            });
            //  alert('Please select a Vendor Name');
            return;
        }
        else {
            let CreateNewPOBO = {
                Employee_Email: CookieService.getLocalStorageValues("Session_EMAIL"),
                Work_Order_No: this.state.WONUM,
                Vendor_ID: this.state.VendorName.value,
                vendor_name: this.state.VendorName.label,
                SDI: "WEB"
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            OrderEntryAction.CreateNewPO(CreateNewPOBO);
        }
    };
    // ASOE_PC_18 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    CreateNewBtn_Response = () => {
        

        let GenPODet = JSON.parse(OrderEntryStore.CreateNew);
        let PONumber = GenPODet.POno;
        let status = GenPODet.status;
        let IsSuccess = false;
        if (PONumber != undefined && PONumber != "") {
            IsSuccess = true;
            this.setState({ GeneratedPo: PONumber, IsPOGenerated: IsSuccess });
            $('#successpopup').modal('show');
        }
        else {
            IsSuccess = false;
            this.setState({ GeneratedPo: status, IsPOGenerated: IsSuccess });
            $('#successpopup').modal('show');

        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({ isCreateNew: false })
        this.Page_Load();

    };
    // ASOE_PC_19 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    DoneClick = () => {
        $('#successpopup').modal('hide');
    }
    // ASOE_PC_13 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    BindGridData = () => {
        
        if (this.state.POGridArray.length > 0) {

            return this.state.POGridArray.map((value, index) => {

                return (<React.Fragment key={index}>{value.ORDER_NO != "" ? <>
                    <tr>

                        <td>{value.POID}</td>
                        <td>{value.ISA_WORK_ORDER_NO}</td>
                        <td>{value.VENDOR_NAME}</td>
                        <td >
                            <td className="text-center px-0" style={{ "borderBottom": "0px solid" }}><span onClick={(e) => this.LineLevelCopy_Click(e, value.POID)}><img className="px-1" src="Images/CopyImage.png" alt="Copy" title="Copy" style={{ height: '20px' }} /></span></td>
                        </td>

                    </tr>
                </> : null}
                </React.Fragment>


                );

            })

        }
    };
    handleVendorIdChange = (e) => {
        
        this.setState(
            { VendorName: e });
    };
    // ASOE_PC_14 WW-475 Add page in the app to create a Supplier PO ID to support Summary Billing replacement
    LineLevelCopy_Click = (e, POID) => {
        Copy(POID);
        MenuAction.CopyMessage();
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(OrderEntryStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        if (OrderEntryStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(OrderEntryStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(OrderEntryStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }

    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath,
                pageTitle: "Walk-In",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            OrderEntryAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            OrderEntryAction.deleteFavPage(deleteFavPageBO)
        }
    };
    //WAL-1034_PC_37 -Aparna
    AnykeyPress(e) {
        if (e.keyCode == 13) {
            this.WOText.current.blur();
            this.WorkOrderInputCheck(false);
        }
    };
    //[10/6/22], WW-475-WO validation - Changed the onkeypress event to onKeyDown event, PC_AOE_01, Dhevanesam R
    WorkOrderInputCheck = (isCreateNew) => {
        
        if (this.state.WONUM == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Enter Work Order'
            });
            //  alert('Please Enter Work Order');
            return;
        } else if (!this.state.IsValidWO) {
            if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                let THIRDPARTY_COMP_ID = ""
                if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                    THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                }
                let BO = {
                    workOrder: this.state.WONUM,
                    Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                    User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    is_WO_Parts_Needed: true
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');

                ShoppingCartAction.WorkOrderCheck(BO)
                this.setState({ workorderclick: true, submitbtn: false, isCreateNew: isCreateNew });
            }
            else {
                $("#OLWorkOrderTB").addClass("disabledbutton");
                this.setState({ workorderclick: true, submitbtn: false, isCreateNew: isCreateNew, IsValidWO: true });
            }

        }
        else {
            if (isCreateNew) {
                this.CreateNewBtn_Click();
            }
        }

    };
    WONumChange = (e) => {
        //WW-742_PC_06 -Aparna
        const onlyNumbers = SDIConstants.quantityRegEX;
        if (e.target.value === '' || onlyNumbers.test(e.target.value)) {
            this.setState({ WONUM: e.target.value });
        }
    }
    ClearWO = () => {
        this.setState({ WONUM: "", IsValidWO: false });
        localStorage.removeItem('WONum')
        localStorage.removeItem('StoreValue')
        localStorage.removeItem('WO_Parts') //BUG:3618 -Aparna
        //[10/18/22, WAL - 785 Getting Asset Tag and storing in a cookie value, Dhevanesam R
        CookieService.updateLocalStorageValues("AssetTag", "");
        CookieService.updateLocalStorageValues("AssetID", "");
        CookieService.updateLocalStorageValues("Trade", "");
        CookieService.updateLocalStorageValues("Category", "");
        CookieService.updateLocalStorageValues("Make", "");
        CookieService.updateLocalStorageValues("Model", "");
        //  CookieService.updateLocalStorageValues("WO_Parts", ""); //BUG:3618 -Aparna
        CookieService.updateLocalStorageValues("WO_Address", "");
        CookieService.updateLocalStorageValues("WO_Priority", "");
        CookieService.updateLocalStorageValues("NTEAmount", "");
        CookieService.updateLocalStorageValues("Session_WO_STATE", ""); //WW-1231 WO State Restriction -Vishwa S
        $("#OLWorkOrderTB").removeClass("disabledbutton");
    }
    Workorderresponse = () => {
        
        localStorage.setItem('WONum', this.state.WONUM);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let BilltoStoreLocationLat = 0;
        let BilltoStoreLocationLong = 0;
        let Workorderresponse = JSON.parse(ShoppingCartStore.workorderresponse);
        let validation = false;
        let locWO_Parts = [];
        let loacalloc = "";
        if (Workorderresponse.WOResponse) {
            if (Workorderresponse.WOResponse.length > 0) {
                if (Workorderresponse.WOResponse[0].ADDRESS1 != "" && Workorderresponse.WOResponse[0].ADDRESS1 != null && Workorderresponse.WOResponse[0].ADDRESS1 != undefined && Workorderresponse.WOResponse[0].ADDRESS1 != " ") {
                    CookieService.updateLocalStorageValues("WO_Address", Workorderresponse.WOResponse[0].ADDRESS1);
                    validation = true;
                };
                CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
                /*[12/24/21, PC_SC_02], Priyanka D//Updating the Location storage*/
                let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
                CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
                let loacalloc = Workorderresponse.WOResponse[0].LOCATION
                localStorage.setItem("StoreValue", JSON.stringify(loacalloc))
                CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
                localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
                //WW-591_PC_02 -Aparna
                CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
                CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
                CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
                CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
                CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
                CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE); //WW-1231 WO State Restriction -Vishwa S
                CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO);// Set stating the ship to tho the ISBlanketWO of the user selects the ship to location as W09301
                //WAL-1034_PC_02 (WO parts)-Aparna
                BilltoStoreLocationLat = Workorderresponse.WOResponse[0].LATITUDE;
                BilltoStoreLocationLong = Workorderresponse.WOResponse[0].LONGITUDE;
                localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);

                //WW-1374 Update the WO store, logo, Problem code long and short description to cookie - Nandhini L 
                loacalloc = Workorderresponse.WOResponse[0].LOCATION
                localStorage.setItem("StoreValue", JSON.stringify(loacalloc));

                CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
                CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
                CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

                if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                    if (Workorderresponse.WOParts.length > 0) {
                        // CookieService.updateLocalStorageValues("WO_Parts", Workorderresponse.WOParts);
                        localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts)) //BUG:3618 -Aparna
                        locWO_Parts = Workorderresponse.WOParts
                        $('#WO_Parts_Popup').modal('show');

                    }
                }


            }
            this.setState({ WO_Parts: locWO_Parts })

        };

        $("#OLWorkOrderTB").addClass("disabledbutton");
        this.setState({ IsValidWO: validation });
        if (this.state.isCreateNew) {
            this.CreateNewBtn_Click();
        }
    };
    workorderfail = () => {
        //WAL-1034_PC_31 -Aparna
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: 'Enter Valid Work Order #'
        });
        // alert('Please Enter a valid Work Order');
        //WW-719_PC_32 -Aparna
        this.setState({ IsValidWO: false, WONUM: "" });
        window.scrollTo(0, 0);
    }
    /***
* 
* */
    WO_Parts_ButtonClick = () => {
        $('#WO_Parts_Popup').modal('show');
    }
    WOClose = () => {
        $('#WO_Parts_Popup').modal('hide');
    }
    render() {
        return (
            <div className="container-fluid content-section custom-mb">
                <div className="row">
                    <div className="col-md-12 page-heading">
                        <h5 className="page-title"><Trans>Walk-In</Trans></h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-Fav">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 my-3">
                        <div className="row justify-content-between">
                            <div className="col-md-auto col-lg-auto mb-3 text-left">
                                <div className="row">
                                    <label className="catalog-label form-label ml-2">* Work Order #</label>
                                    <div className="input-group charge-code-group mb-2 ml-2">
                                        {/*WW-475-WO validation shld happen in onKeypres event*/}
                                        {/*[10/6/22], WW-475-WO validation - Changed the onkeypress event to onKeyDown event, PC_AOE_01, Dhevanesam R*/}
                                        <input type="text" className="form-control charge-code-control" placeholder="Enter value" id="OLWorkOrderTB" ref={this.WOText} maxLength="9" onKeyDown={this.AnykeyPress} value={this.state.WONUM} onChange={e => this.WONumChange(e)} defaultValue={''} />

                                        {this.state.WONUM != undefined && this.state.WONUM != null && this.state.WONUM != "" && this.state.WONUM != " " ?
                                            < span class="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.ClearWO()} ></span> : null
                                        }
                                        <div className="input-group-append" >
                                            <span className="input-group-text" onClick={(e) => this.WorkOrderInputCheck(false)} >
                                                <span className="shopping-search-icon" />
                                            </span>
                                        </div>
                                    </div>
                                    {this.state.IsValidWO == true && this.state.WO_Parts.length > 0 ? <div className="ml-2">
                                        <button class="btn btn-labeled btn-primary custom-btn-primary ShoppingCart-Top-Button primary-btn" onClick={() => this.WO_Parts_ButtonClick()} >
                                            <img src="Images/history_icon.svg" alt="History-icon" /> WO# History</button>
                                    </div> : null}
                                    <div class="ml-2"><button class="btn btn-primary custom-btn-primary primary-btn px-3" onClick={() => this.WorkOrderInputCheck(true)} >+ Create New</button></div>

                                </div>
                            </div>
                            <div className="col-lg-auto col-md-auto mb-3">
                                <div className="row">
                                    <label className="catalog-label mt-2 mr-3"><Trans>Vendor Name</Trans></label>
                                    <div style={{ "fontSize": "12px", "width": "326px" }} className="pr-0 ml-2 mb-2" ><Select
                                        id="buddid"
                                        name="BuDD"
                                        onChange={(e) => this.handleVendorIdChange(e)}
                                        value={this.state.VendorName}
                                        defaultValue="Select"
                                        options={this.state.VendorArray}
                                    /></div>
                                    <div className="ml-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={this.GoButton_Click}><Trans>GO</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.POGridArray.length > 0 ?
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                    <thead>
                                        <tr>
                                            <th className="position-sort-icon" style={{ "width": "20px" }}><Trans>PO ID</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Work Order</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Vendor Name</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Copy PO ID</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.BindGridData()}
                                    </tbody>
                                </table>

                            </div>
                        </div> : (<section className="site-undercontruction container text-center center-panel pt-4">
                            <div className="img-section">
                                <img src="images/nosearch.jpg" alt="imagefile" />
                            </div>
                            <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                            </p>
                        </section>)}

                </div>
                <div className="modal" id="successpopup" >
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-12">
                                        <div className="text-center mt-2">
                                            {this.state.IsPOGenerated ? <img src="Images/success-alert.png" alt="Po Generation Success" /> : <img src="Images/close.png" alt="Po Generation Failed" />}
                                        </div>
                                        <div className="text-center my-4">
                                            {this.state.IsPOGenerated ? <label className="catalog-label w-100">Requested PO# </label> : ""}
                                            <label className="item-details-value  w-100">
                                                <span className="info-label">{this.state.GeneratedPo}</span>
                                                {this.state.IsPOGenerated ? <span onClick={(e) => this.LineLevelCopy_Click(e, this.state.GeneratedPo)}><img className="px-1" src="Images/CopyImage.png" alt="Copy" title="Copy" style={{ height: '20px' }} /></span> : ""}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={e => this.DoneClick(e)}>Done</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* WAL-1034_PC_13 WO parts */}
                <div className="modal" id="WO_Parts_Popup" >
                    {this.state.IsValidWO && this.state.WO_Parts.length > 0 ?
                        <WOPartsComponent closePopup={this.WOClose}  {...this.props} /> : null}
                </div>
            </div>
        );
    };
};
export default withTranslation()(OrderEntryComponent);